import React, { useState, useEffect, useMemo } from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/ui/Header";
import Icon from "../../components/AppIcon";
import Button from "../../components/ui/Button";
import CourseCard from "./components/CourseCard";
import FilterSidebar from "./components/FilterSidebar";
import CourseComparison from "./components/CourseComparison";
import CourseDetailsModal from "./components/CourseDetailsModal";

const CoursesPage = () => {
  const [filters, setFilters] = useState({
    search: "",
    categories: [],
    levels: [],
    durations: [],
    modes: [],
    certifications: [],
    minRating: null,
  });

  const [sortBy, setSortBy] = useState("popularity");
  const [viewMode, setViewMode] = useState("grid");
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isComparisonOpen, setIsComparisonOpen] = useState(false);
  const [comparisonCourses, setComparisonCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);

  // course data
  const allCourses = [
    {
      id: 1,
      title: "ICT Technician Level 4",
      category: "ICT Technician",
      duration: "8 months",
      level: "Four",
      image: "/assets/images/Trainees_ICTLabSession2-min.JPG",
      description:
        "Build foundational skills in information and communication technology, including computer operations, basic networking, hardware setup, and software installation.",
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",

      schedule: {
        days: "Mon - Fri",
        time: "8:00 AM - 5:00 PM",
        sessionDuration: "2 hours",
      },
    },
    {
      id: 2,
      title: "ICT Technician Level 5",
      category: "ICT Technician",
      duration: "24 Months",
      level: "Five",
      image: "/assets/images/Trainees_ICTLabSession2-min.JPG",
      description:
        "Advance your ICT expertise with computer programming, database systems, network management, and basic electronics for IT support roles.",
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 3,
      title: "Cybersecurity Level 6",
      category: "Cybersecurity",
      duration: "36 Months",
      level: "Six",
      image: "/assets/images/Trainees_ICTLabSession2-min.JPG",
      description:
        "Master advanced cybersecurity techniques including ethical hacking, digital forensics, security auditing, and incident management for senior security roles.",
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "KCSE D+, Cybersecurity Level 5",
    },
    {
      id: 4,
      title: "ICT Technician Level 6",
      category: "ICT Technician",
      duration: "36 Months",
      level: "Six",
      image: "/assets/images/Trainees_ICTLabSession2-min.JPG",
      description:
        "Master advanced ICT skills including software development, system analysis, IT project management, and entrepreneurial skills for leadership in technology.",
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "ICT Technician Level 5, KCSE D+",
    },
    {
      id: 5,
      title: "Building Technician Level 5",
      category: "Building Technology",
      duration: "24 Months",
      level: "Five",
      image: "/assets/images/Trainees_in_Carpentry1-min.JPG",
      description:
        "Develop skills in building construction, architectural drawing, material science, and construction management for technician roles in the building industry.",
      certification: "TVET CDACC",

      rating: "",
      mode: "On Campus",
      prerequisites: "Building Technician Level 4, KCSE D+",
    },
    {
      id: 6,
      title: "Building Technician Level 6",
      category: "Building Technology",
      duration: "36 Months",
      level: "Six",
      image: "/assets/images/Trainees_in_Carpentry1-min.JPG",
      description:
        "Master advanced building technology including project management, sustainable construction, building services, and entrepreneurial skills for leadership in construction.",
      certification: "TVET CDACC",

      rating: "",

      mode: "On Campus",
      prerequisites: "Building Technician Level 5, KCSE D+",
    },
    {
      id: 7,
      title: "Civil Engineering Level 5",
      category: "Civil Engineering",
      duration: "24 Months",
      level: "Five",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Gain expertise in civil engineering fundamentals including structural design, surveying, construction materials, and project planning for engineering technician roles.",

      certification: "TVET CDACC",

      rating: "",

      mode: "On Campus",
      prerequisites: "Civil Engineering Level 4, KCSE D+",
    },
    {
      id: 8,
      title: "Carpentry & Joinery Level 5",
      category: "Building Technology",
      duration: "24 Months",
      level: "Five",
      image: "/assets/images/Trainees_in_Carpentry1-min.JPG",
      description:
        "Master woodworking skills including furniture making, cabinet construction, timber treatment, and joinery techniques for carpentry professionals.",

      certification: "TVET CDACC",

      rating: "",

      mode: "On Campus",
      prerequisites: "Carpentry & Joinery Level 4, KCSE D+",
    },
    {
      id: 9,
      title: "Carpentry & Joinery Level 6",
      category: "Building Technology",
      duration: "36 Months",
      level: "Six",
      image: "/assets/images/Trainees_in_Carpentry1-min.JPG",
      description:
        "Advance to expert level carpentry with advanced joinery, furniture design, workshop management, and entrepreneurial skills for business ownership.",

      certification: "TVET CDACC",

      rating: "",

      mode: "On Campus",
      prerequisites: "Carpentry & Joinery Level 5, KCSE D+",
    },
    {
      id: 10,
      title: "Cybersecurity Level 5",
      category: "Cybersecurity",
      duration: "24 Months",
      level: "Five",
      image: "/assets/images/Trainees_ICTLabSession2-min.JPG",
      description:
        "Build essential cybersecurity skills in network security, ethical hacking basics, cryptography, and security protocols for entry-level security positions.",

      certification: "TVET CDACC",

      rating: "",

      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 11,
      title: "Office Administration Level 5",
      category: "Business",
      duration: "24 Months",
      level: "Five",
      image: "/assets/images/Trainees_ICTLabSession3-min.JPG",
      description:
        "Develop administrative skills in office management, business communication, records management, and customer service for administrative assistant roles.",

      certification: "TVET CDACC",

      rating: "",

      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 12,
      title: "Office Administration Level 6",
      category: "Business",
      duration: "36 Months",
      level: "Six",
      image: "/assets/images/Trainees_ICTLabSession3-min.JPG",
      description:
        "Master advanced office administration including project management, human resource management, financial administration, and leadership skills for senior administrative positions.",
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 13,
      title: "Supply Chain Management Level 5",
      category: "Business",
      duration: "24 Months",
      level: "Five",
      image: "/assets/images/Trainees_ICTLabSession2-min.JPG",
      description:
        "Learn supply chain fundamentals including procurement, inventory management, logistics, and warehouse operations for supply chain coordinator roles.",
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 14,
      title: "Supply Chain Management Level 6",
      category: "Business",
      duration: "36 Months",
      level: "Six",
      image: "/assets/images/Trainees_ICTLabSession3-min.JPG",
      description:
        "Master advanced supply chain management including strategic planning, international logistics, supply chain analytics, and leadership for senior management positions.",
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 15,
      title: "Certified Public Accountant (CPA)",
      category: "KASNEB Courses",
      duration: "4 months",
      level: "Advanced",
      image: "/assets/images/Trainees_ICTLabSession3-min.JPG",
      description:
        "Professional accounting qualification covering financial accounting, auditing, taxation, and business law for certified public accountant certification.",
      certification: "KASNEB",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 16,
      title: "Accounting Technician Diploma (ATD) Level III",
      category: "KASNEB Courses",
      duration: "4 months",
      level: "Advanced",
      image: "/assets/images/Trainees_ICTLabSession3-min.JPG",
      description:
        "Advanced accounting technician training covering financial reporting, management accounting, and business finance for senior accounting technician roles.",

      certification: "KASNEB",

      rating: "",

      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 17,
      title: "Accounting Technician Diploma (ATD) Level II",
      category: "KASNEB Courses",
      duration: "4 months",
      level: "Advanced",
      image: "/assets/images/Trainees_ICTLabSession3-min.JPG",
      description:
        "Intermediate accounting technician training covering bookkeeping, financial statements, and basic taxation for accounting support roles.",

      certification: "KASNEB",

      rating: "",

      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 18,
      title: "Accounting Technician Diploma (ATD) Level I",
      category: "KASNEB Courses",
      duration: "4 months",
      level: "Advanced",
      image: "/assets/images/Trainees_ICTLabSession3-min.JPG",
      description:
        "Foundation accounting technician training covering basic bookkeeping, business mathematics, and introduction to accounting principles.",

      certification: "KASNEB",

      rating: "",

      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 19,
      title: "Certificate in Accounting & Management Skills (CAMS)",
      category: "KASNEB Courses",
      duration: "4 months",
      level: "Advanced",
      image: "/assets/images/Trainees_ICTLabSession3-min.JPG",
      description:
        "Comprehensive training in accounting principles, business management, and administrative skills for entry-level business and accounting positions.",

      certification: "KASNEB",

      rating: "",

      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 20,
      title: "Counselling Psychology Level 5",
      category: "Social Work",
      duration: "24 Months",
      level: "Five",
      image: "/assets/images/Trainees_ICTLabSession2-min.JPG",
      description:
        "Develop foundational counselling skills including psychology principles, therapeutic communication, and basic counselling techniques for mental health support roles.",

      certification: "TVET CDACC",

      rating: "",

      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 21,
      title: "Counselling Psychology Level 6",
      category: "Social Work",
      duration: "36 Months",
      level: "Six",
      image: "/assets/images/Trainees_ICTLabSession2-min.JPG",
      description:
        "Master advanced counselling psychology including psychotherapy, mental health assessment, crisis intervention, and professional practice for clinical counselling roles.",

      certification: "TVET CDACC",

      rating: "",

      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 22,
      title: "Social Work & Community Development Level 5",
      category: "Social Work",
      duration: "24 Months",
      level: "Five",
      image: "/assets/images/Trainees_ICTLabSession2-min.JPG",
      description:
        "Learn social work fundamentals including community development, social welfare, case management, and advocacy for social service coordinator roles.",

      certification: "TVET CDACC",

      rating: "",

      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 23,
      title: "Social Work & Community Development Level 6",
      category: "Social Work",
      duration: "36 Months",
      level: "Six",
      image: "/assets/images/Trainees_ICTLabSession2-min.JPG",
      description:
        "Master advanced social work including program development, policy analysis, community leadership, and professional practice for senior social work positions.",

      certification: "TVET CDACC",

      rating: "",

      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 24,
      title: "Interior Design Level 5",
      category: "Building Technology",
      duration: "24 Months",
      level: "Five",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Develop interior design skills including space planning, color theory, materials selection, and design software for interior design assistant roles.",

      certification: "TVET CDACC",

      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 25,
      title: "Interior Design Level 6",
      category: "Building Technology",
      duration: "36 Months",
      level: "Six",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Master advanced interior design including project management, sustainable design, lighting design, and business development for professional interior designer roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 26,
      title: "Land Surveying Level 5",
      category: "Civil Engineering",
      duration: "24 Months",
      level: "Five",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Learn land surveying fundamentals including topographic surveying, GPS technology, mapping, and legal aspects for surveying technician roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 27,
      title: "Land Surveying Level 6",
      category: "Civil Engineering",
      duration: "36 Months",
      level: "Six",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Master advanced surveying including cadastral surveying, engineering surveys, GIS applications, and project management for professional surveyor roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },

    {
      id: 28,
      title: "Quantity Surveying Level 6",
      category: "Civil Engineering",
      duration: "36 Months",
      level: "Six",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Master quantity surveying including cost planning, contract administration, project management, and procurement for professional quantity surveyor roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },

    {
      id: 29,
      title: "Quantity Surveying Level 5",
      category: "Civil Engineering",
      duration: "24 Months",
      level: "Five",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Learn quantity surveying fundamentals including measurement, estimating, cost control, and construction economics for quantity surveying assistant roles.",

      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },

    {
      id: 30,
      title: "Plumbing Level 4",
      category: "Building Technology",
      duration: "8 months",
      level: "Four",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Build foundational plumbing skills including pipe fitting, water systems, drainage, and basic plumbing maintenance for plumbing assistant roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },

    {
      id: 31,
      title: "Plumbing Level 5",
      category: "Building Technology",
      duration: "24 Months",
      level: "Five",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Develop plumbing expertise including advanced pipe systems, heating systems, plumbing codes, and maintenance for certified plumbing technician roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },

    {
      id: 32,
      title: "Plumbing Level 6",
      category: "Building Technology",
      duration: "36 Months",
      level: "Six",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Master advanced plumbing including design, project management, sustainable systems, and business development for master plumber and contractor roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },

    {
      id: 33,
      title: "Beauty Therapy Level 4",
      category: "Cosmetology",
      duration: "8 months",
      level: "Four",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Learn foundational beauty therapy skills including skincare, basic makeup, manicure/pedicure, and salon hygiene for beauty assistant roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },

    {
      id: 34,
      title: "Beauty Therapy Level 5",
      category: "Cosmetology",
      duration: "24 Months",
      level: "Five",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Develop beauty therapy expertise including advanced skincare treatments, makeup artistry, nail technology, and customer service for beauty therapist positions.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },

    {
      id: 35,
      title: "Beauty Therapy Level 6",
      category: "Cosmetology",
      duration: "36 Months",
      level: "Six",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Master advanced beauty therapy including specialized treatments, business management, product knowledge, and training skills for salon ownership and senior therapist roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },

    {
      id: 36,
      title: "Hairdressing Level 4",
      category: "Cosmetology",
      duration: "8 months",
      level: "Four",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Learn foundational hairdressing skills including basic cutting, styling, coloring basics, and salon safety for hairdressing assistant roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },

    {
      id: 37,
      title: "Hairdressing Level 5",
      category: "Cosmetology",
      duration: "24 Months",
      level: "Five",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Develop hairdressing expertise including advanced cutting techniques, chemical services, hair treatments, and customer consultation for stylist positions.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },

    {
      id: 38,
      title: "Hairdressing Level 6",
      category: "Cosmetology",
      duration: "36 Months",
      level: "Six",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Master advanced hairdressing including creative styling, business management, training skills, and specialized techniques for salon ownership and senior stylist roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },

    {
      id: 39,
      title: "Baking Technology Level 4",
      category: "Hospitality",
      duration: "8 months",
      level: "Four",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Learn foundational baking skills including dough preparation, basic pastries, food safety, and kitchen hygiene for bakery assistant roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },

    {
      id: 40,
      title: "Baking Technology Level 5",
      category: "Hospitality",
      duration: "24 Months",
      level: "Five",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Develop baking expertise including advanced pastry techniques, cake decoration, bread making, and quality control for professional baker positions.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },

    {
      id: 41,
      title: "Baking Technology Level 6",
      category: "Hospitality",
      duration: "36 months",
      level: "Six",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Master advanced baking including artisanal techniques, business management, menu development, and training skills for bakery ownership and head baker roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },

    {
      id: 42,
      title: "Food & Beverage Production & Service Level 4",
      category: "Hospitality",
      duration: "8 months",
      level: "Four",
      image: "/assets/images/FoodProductionKitchen_1-min.JPG",
      description:
        "Learn foundational food and beverage skills including food preparation, service basics, hygiene standards, and customer service for hospitality assistant roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 43,
      title: "Food & Beverage Production & Service Level 5",
      category: "Hospitality",
      duration: "24 months",
      level: "Five",
      image: "/assets/images/FoodProductionKitchen_1-min.JPG",
      description:
        "Develop food and beverage expertise including advanced cooking techniques, beverage service, menu planning, and quality control for professional chef and server positions.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 44,
      title: "Food & Beverage Production & Service Level 6",
      category: "Hospitality",
      duration: "36 Months",
      level: "Six",
      image: "/assets/images/FoodProductionKitchen_1-min.JPG",
      description:
        "Master advanced food and beverage operations including culinary arts, restaurant management, nutrition, and business development for executive chef and hospitality management roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 45,
      title: "Catering & Accommodation Services Level 4",
      category: "Hospitality",
      duration: "8 months",
      level: "Four",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Learn foundational catering and accommodation skills including housekeeping, event setup, basic catering, and guest services for hospitality support roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 46,
      title: "Catering & Accommodation Services Level 5",
      category: "Hospitality",
      duration: "24 Months",
      level: "Five",
      image: "/assets/images/FoodProductionKitchen_1-min.JPG",
      description:
        "Develop catering and accommodation expertise including event management, accommodation operations, advanced catering, and customer service for professional hospitality positions.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 47,
      title: "Catering & Accommodation Services Level 6",
      category: "Hospitality",
      duration: "36 Months",
      level: "Six",
      image: "/assets/images/FoodServicePractical_2-min.JPG",
      description:
        "Master advanced hospitality management including hotel operations, event planning, business development, and leadership skills for hospitality management and ownership roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 48,
      title: "Fashion & Design Technology Level 4",
      category: "Fashion Design",
      duration: "8 months",
      level: "Four",
      image: "/assets/images/Equipment2_Cosmetology-min.JPG",
      description:
        "Learn foundational fashion design skills including pattern making, sewing basics, fabric knowledge, and design principles for fashion assistant roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 49,
      title: "Fashion & Design Technology Level 5",
      category: "Fashion Design",
      duration: "24 Months",
      level: "Five",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Develop fashion design expertise including advanced pattern making, garment construction, textile technology, and fashion illustration for designer assistant positions.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 50,
      title: "Fashion & Design Technology Level 6",
      category: "Fashion Design",
      duration: "36 Months",
      level: "Six",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Master advanced fashion design including collection development, business management, marketing, and entrepreneurial skills for fashion designer and brand ownership roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 51,
      title: "Tour & Travel Management Level 5",
      category: "Tourism & Travel",
      duration: "24 Months",
      level: "Five",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Develop tourism and travel skills including destination knowledge, tour planning, customer service, and booking systems for travel consultant positions.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 52,
      title: "Tour & Travel Management Level 6",
      category: "Tourism & Travel",
      duration: "36 Months",
      level: "Six",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Master advanced tourism management including strategic planning, international tourism, business development, and leadership skills for tourism management and agency ownership roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 53,
      title: "Electrical Engineering Level 6",
      category: "Electrical Engineering",
      duration: "36 Months",
      level: "Six",
      image: "/assets/images/Electrical_TraineesPractical5-min.JPG",
      description:
        "Master advanced electrical engineering including power systems, automation, project management, and leadership skills for senior engineering and management roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 54,
      title: "Electrical Engineering Level 5",
      category: "Electrical Engineering",
      duration: "24 Months",
      level: "Five",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Develop electrical engineering skills including circuit design, power distribution, control systems, and technical drawing for engineering technician positions.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 55,
      title: "Electrical Installation Level 4",
      category: "Electrical Engineering",
      duration: "8 months",
      level: "Four",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Learn foundational electrical installation skills including wiring, basic circuits, safety procedures, and electrical tools for installation assistant roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 56,
      title: "Electrical Installation Level 5",
      category: "Electrical Engineering",
      duration: "24 Months",
      level: "Five",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Develop electrical installation expertise including advanced wiring, electrical systems, maintenance, and inspection for certified electrician positions.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 57,
      title: "Electrical Installation Level 6",
      category: "Electrical Engineering",
      duration: "36 Months",
      level: "Six",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Master advanced electrical installation including complex systems, project management, business development, and supervisory skills for master electrician and contracting roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 58,
      title: "Solar PV Installation Level 4",
      category: "Electrical Engineering",
      duration: "8 months",
      level: "Four",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Learn solar photovoltaic installation fundamentals including panel mounting, electrical connections, safety protocols, and basic maintenance for solar technician assistant roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 59,
      title: "Agricultural Extension Level 4",
      category: "Agriculture",
      duration: "8 months",
      level: "Four",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Learn foundational agricultural extension skills including crop production, livestock management, farm planning, and community outreach for agricultural assistant roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 60,
      title: "Agricultural Extension Level 5",
      category: "Agriculture",
      duration: "24 Months",
      level: "Five",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Develop agricultural extension expertise including advanced farming techniques, extension methodologies, project management, and rural development for extension officer positions.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 61,
      title: "Agricultural Extension Level 6",
      category: "Agriculture",
      duration: "36 Months",
      level: "Six",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Master advanced agricultural extension including policy development, program management, research methods, and leadership skills for senior extension and development roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 62,
      title: "Aquaculture Level 4",
      category: "Agriculture",
      duration: "8 months",
      level: "Four",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Learn foundational aquaculture skills including fish farming basics, pond management, water quality monitoring, and fish health for aquaculture assistant roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 63,
      title: "Aquaculture Level 5",
      category: "Agriculture",
      duration: "24 Months",
      level: "Five",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Develop aquaculture expertise including advanced fish farming techniques, hatchery management, disease control, and business planning for aquaculture technician positions.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 64,
      title: "Aquaculture Level 6",
      category: "Agriculture",
      duration: "36 Months",
      level: "Six",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Master advanced aquaculture including sustainable practices, research methods, project management, and entrepreneurial skills for aquaculture management and business ownership.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 65,
      title: "Apiculture Management Level 5",
      category: "Agriculture",
      duration: "24 Months",
      level: "Five",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Develop beekeeping expertise including hive management, honey production, bee health, and pollination services for professional beekeeper positions.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 66,
      title: "Apiculture Management Level 6",
      category: "Agriculture",
      duration: "36 Months",
      level: "Six",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Master advanced beekeeping including queen rearing, disease management, business development, and training skills for apiculture business ownership and consultancy.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 67,
      title: "Sustainable Agriculture & Rural Development Level 5",
      category: "Agriculture",
      duration: "24 Months",
      level: "Five",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Learn sustainable agriculture practices including organic farming, environmental conservation, rural economics, and community development for development assistant roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 68,
      title: "Sustainable Agriculture & Rural Development Level 6",
      category: "Agriculture",
      duration: "36 Months",
      level: "Six",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Master sustainable development including policy analysis, project management, environmental impact assessment, and leadership skills for rural development specialist roles.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 69,
      title: "Masonry Level 4",
      category: "Dual TVET",
      duration: "8 months",
      level: "Four",
      image: "/assets/images/Trainees_Building3-min.jpg",
      description:
        "Learn foundational masonry skills including bricklaying, concrete work, stone work, and construction safety for masonry assistant roles in dual training programs.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 70,
      title: "Electrical Installation Level 4",
      category: "Dual TVET",
      duration: "8 months",
      level: "Four",
      image: "/assets/images/Lecture_Theatre+BlockA-min.jpeg",
      description:
        "Learn foundational electrical installation skills including wiring, basic circuits, safety procedures, and electrical tools for installation assistant roles in dual training programs.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 71,
      title: "Catering & Accommodation Level 4",
      category: "Dual TVET",
      duration: "8 months",
      level: "Four",
      image: "/assets/images/FoodServicePracticalLesson_1-min.JPG",
      description:
        "Learn foundational catering and accommodation skills including food preparation, service basics, housekeeping, and guest services for hospitality support roles in dual training programs.",
      skills: [],
      certification: "TVET CDACC",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 72,
      title: "Masonry",
      category: "RPL Programs",
      duration: "",
      level: "",
      image: "assets/images/RPLBrochure.jpeg",

      description:
        "Unlock your potential and turn your experience into a recognized qualification!.",
      skills: [],
      certification: "KARUMO TTI",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 73,
      title: "Cosmetology - Beauty Therapy , Hairdressing",
      category: "RPL Programs",
      duration: "",
      level: "",
      image: "assets/images/RPLBrochure.jpeg",

      description:
        "Unlock your potential and turn your experience into a recognized qualification!.",
      skills: [],
      certification: "KARUMO TTI",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 74,
      title: "Plumbing",
      category: "RPL Programs",
      duration: "",
      level: "",
      image: "assets/images/RPLBrochure.jpeg",
      description:
        "Unlock your potential and turn your experience into a recognized qualification!.",
      skills: [],
      certification: "KARUMO TTI",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
    {
      id: 75,
      title: "Electrical and Electronics Engineering",
      category: "RPL Programs",
      duration: "",
      level: "",
      image: "assets/images/RPLBrochure.jpeg",
      description:
        "Unlock your potential and turn your experience into a recognized qualification!.",
      skills: [],
      certification: "KARUMO TTI",
      rating: "",
      mode: "On Campus",
      prerequisites: "",
    },
  ];

  // Filter and sort courses
  const filteredAndSortedCourses = useMemo(() => {
    let filtered = allCourses?.filter((course) => {
      // Search filter
      if (
        filters?.search &&
        !course?.title
          ?.toLowerCase()
          ?.includes(filters?.search?.toLowerCase()) &&
        !course?.category
          ?.toLowerCase()
          ?.includes(filters?.search?.toLowerCase()) &&
        !course?.skills?.some((skill) =>
          skill?.toLowerCase()?.includes(filters?.search?.toLowerCase()),
        )
      ) {
        return false;
      }

      // Category filter
      if (
        filters?.categories?.length > 0 &&
        !filters?.categories?.includes(course?.category)
      ) {
        return false;
      }

      // Level filter
      if (
        filters?.levels?.length > 0 &&
        !filters?.levels?.includes(course?.level)
      ) {
        return false;
      }

      // Duration filter
      if (filters?.durations?.length > 0) {
        const courseDurationMonths = parseInt(course?.duration);
        const matchesDuration = filters?.durations?.some((duration) => {
          if (duration === "6-12 months")
            return courseDurationMonths >= 6 && courseDurationMonths <= 12;
          if (duration === "1 year")
            return courseDurationMonths > 12 && courseDurationMonths <= 24;
          // if (duration === '2+ years') return courseDurationMonths > 24 && courseDurationMonths <= 12;
          if (duration === "2+ years") return courseDurationMonths > 24;
          return false;
        });
        if (!matchesDuration) return false;
      }

      // Mode filter
      if (
        filters?.modes?.length > 0 &&
        !filters?.modes?.includes(course?.mode)
      ) {
        return false;
      }

      // Certification filter
      if (
        filters?.certifications?.length > 0 &&
        !filters?.certifications?.includes(course?.certification)
      ) {
        return false;
      }

      // Fee range filter
      if (
        filters?.feeRange?.min &&
        course?.fees < parseInt(filters?.feeRange?.min)
      ) {
        return false;
      }
      if (
        filters?.feeRange?.max &&
        course?.fees > parseInt(filters?.feeRange?.max)
      ) {
        return false;
      }

      // Rating filter
      if (filters?.minRating && course?.rating < filters?.minRating) {
        return false;
      }

      return true;
    });

    // Sort courses
    filtered?.sort((a, b) => {
      switch (sortBy) {
        case "popularity":
          return (
            b?.studentsEnrolled +
            (b?.isPopular ? 1000 : 0) -
            (a?.studentsEnrolled + (a?.isPopular ? 1000 : 0))
          );
        case "rating":
          return b?.rating - a?.rating;
        case "price-low":
          return a?.fees - b?.fees;
        case "price-high":
          return b?.fees - a?.fees;
        case "duration":
          return parseInt(a?.duration) - parseInt(b?.duration);
        case "placement":
          return b?.placementRate - a?.placementRate;
        default:
          return 0;
      }
    });

    return filtered;
  }, [filters, sortBy]);

  // Handle filter changes
  const handleFilterChange = (filterType, value) => {
    setFilters((prev) => ({
      ...prev,
      [filterType]: value,
    }));
  };

  // Clear all filters
  const handleClearFilters = () => {
    setFilters({
      search: "",
      categories: [],
      levels: [],
      durations: [],
      modes: [],
      certifications: [],
      feeRange: { min: "", max: "" },
      minRating: null,
    });
  };

  // Handle course comparison
  const handleCompareToggle = (course) => {
    setComparisonCourses((prev) => {
      const exists = prev?.find((c) => c?.id === course?.id);
      if (exists) {
        return prev?.filter((c) => c?.id !== course?.id);
      } else if (prev?.length < 3) {
        return [...prev, course];
      }
      return prev;
    });
  };

  // Handle course details
  const handleViewDetails = (course) => {
    setSelectedCourse(course);
    setIsDetailsModalOpen(true);
  };

  // Auto-open comparison when courses are added
  useEffect(() => {
    if (comparisonCourses?.length > 0) {
      setIsComparisonOpen(true);
    }
  }, [comparisonCourses]);

  return (
    <div className="min-h-screen bg-blue-100">
      <Helmet>
        <title>Courses - KARUMO TECHNICAL TRAINING INSTITUTE</title>
        <meta
          name="description"
          content="Explore our comprehensive range of TVET CDACC accredited technical courses including ICT, Engineering, Business, Hospitality, and Agriculture programs. Hands-on training for industry-ready professionals."
        />
        <meta
          name="keywords"
          content="technical courses, TVET, CDACC, ICT courses, engineering courses, business courses, hospitality courses, agriculture courses, technical training, Kenya, Meru"
        />
        <meta name="robots" content="index, follow" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://karumotti.ac.ke/courses" />
        <meta
          property="og:title"
          content="Courses - KARUMO TECHNICAL TRAINING INSTITUTE"
        />
        <meta
          property="og:description"
          content="Explore our comprehensive range of TVET CDACC accredited technical courses including ICT, Engineering, Business, Hospitality, and Agriculture programs."
        />
        <meta
          property="og:image"
          content="https://karumotti.ac.ke/kttilogo.png"
        />
        <meta
          property="og:site_name"
          content="KARUMO TECHNICAL TRAINING INSTITUTE"
        />
        <meta property="og:locale" content="en_KE" />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta
          property="twitter:url"
          content="https://karumotti.ac.ke/courses"
        />
        <meta
          property="twitter:title"
          content="Courses - KARUMO TECHNICAL TRAINING INSTITUTE"
        />
        <meta
          property="twitter:description"
          content="Explore our comprehensive range of TVET CDACC accredited technical courses including ICT, Engineering, Business, Hospitality, and Agriculture programs."
        />
        <meta
          property="twitter:image"
          content="https://karumotti.ac.ke/kttilogo.png"
        />

        {/* Canonical URL */}
        <link rel="canonical" href="https://karumotti.ac.ke/courses" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ItemList",
            name: "Technical Courses at KTTI",
            description:
              "Comprehensive list of TVET CDACC accredited technical courses offered at KARUMO TECHNICAL TRAINING INSTITUTE",
            url: "https://karumotti.ac.ke/courses",
            numberOfItems: 6,
            itemListElement: [
              {
                "@type": "Course",
                name: "Computing Informatics & Business",
                description:
                  "Comprehensive program covering software development, Cybersecurity, Networking, Business Administration and emerging technologies.",
                provider: {
                  "@type": "EducationalOrganization",
                  name: "KARUMO TECHNICAL TRAINING INSTITUTE",
                },
                educationalLevel: "TVET Level 4, 5 & 6",
                teaches: [
                  "Software Development",
                  "Cybersecurity",
                  "Business Administration",
                  "Networking",
                ],
              },
              {
                "@type": "Course",
                name: "Building & Civil Engineering",
                description:
                  "Advanced building and civil engineering programmes with focus on design, and automation technologies.",
                provider: {
                  "@type": "EducationalOrganization",
                  name: "KARUMO TECHNICAL TRAINING INSTITUTE",
                },
                educationalLevel: "TVET Level 4, 5 & 6",
                teaches: [
                  "Building Technology",
                  "Civil Engineering",
                  "Construction Management",
                ],
              },
              {
                "@type": "Course",
                name: "Electrical & Electronics Engineering",
                description:
                  "Comprehensive electrical engineering program covering power systems, electronics, and renewable energy.",
                provider: {
                  "@type": "EducationalOrganization",
                  name: "KARUMO TECHNICAL TRAINING INSTITUTE",
                },
                educationalLevel: "TVET Level 4, 5 & 6",
                teaches: [
                  "Power Systems",
                  "Electronics",
                  "Renewable Energy",
                  "Electrical Engineering",
                ],
              },
              {
                "@type": "Course",
                name: "Agriculture & Environmental Studies",
                description:
                  "Comprehensive program in agriculture and environmental studies focusing on sustainable farming and ecological management.",
                provider: {
                  "@type": "EducationalOrganization",
                  name: "KARUMO TECHNICAL TRAINING INSTITUTE",
                },
                educationalLevel: "TVET Level 4, 5 & 6",
                teaches: [
                  "Sustainable Agriculture",
                  "Environmental Management",
                  "Crop Science",
                  "Agribusiness",
                ],
              },
              {
                "@type": "Course",
                name: "Hospitality & Tourism",
                description:
                  "Comprehensive program in hospitality services, institutional management, catering, and event management.",
                provider: {
                  "@type": "EducationalOrganization",
                  name: "KARUMO TECHNICAL TRAINING INSTITUTE",
                },
                educationalLevel: "TVET Level 4, 5 & 6",
                teaches: [
                  "Hospitality Management",
                  "Catering",
                  "Event Management",
                  "Tourism",
                ],
              },
              {
                "@type": "Course",
                name: "Cosmetology & Fashion Design",
                description:
                  "Comprehensive program in cosmetology and fashion design covering beauty services and creative design techniques.",
                provider: {
                  "@type": "EducationalOrganization",
                  name: "KARUMO TECHNICAL TRAINING INSTITUTE",
                },
                educationalLevel: "TVET Level 4, 5 & 6",
                teaches: [
                  "Cosmetology",
                  "Fashion Design",
                  "Beauty Services",
                  "Creative Design",
                ],
              },
            ],
          })}
        </script>
      </Helmet>
      <Header />
      <main className="pt-16">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-primary/5 via-background to-accent/5 py-16">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="text-center mb-12">
              <h1 className="text-4xl lg:text-5xl font-bold text-foreground mb-4">
                Discover Your Perfect Course
              </h1>
              <p className="text-xl text-black w-fit mx-auto">
                Choose from our comprehensive range of industry-focused
                technical courses designed to accelerate your career growth and
                prepare you for the future of work.
              </p>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <section className="py-12">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="flex flex-col lg:flex-row gap-8">
              {/* Sidebar */}
              <div className="lg:w-80 flex-shrink-0">
                <FilterSidebar
                  filters={filters}
                  onFilterChange={handleFilterChange}
                  onClearFilters={handleClearFilters}
                  isOpen={isFilterOpen}
                  onToggle={() => setIsFilterOpen(!isFilterOpen)}
                  totalCourses={allCourses?.length}
                  filteredCount={filteredAndSortedCourses?.length}
                />
              </div>

              {/* Main Content */}
              <div className="flex-1">
                {/* Controls */}
                <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-8">
                  <div className="flex items-center space-x-4">
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => setIsFilterOpen(true)}
                      iconName="Filter"
                      iconPosition="left"
                      className="lg:hidden"
                    >
                      Filters
                    </Button>
                    <p className="text-muted-foreground">
                      Showing {filteredAndSortedCourses?.length} of{" "}
                      {allCourses?.length} courses
                    </p>
                  </div>

                  <div className="flex items-center space-x-4">
                    {/* View Mode Toggle */}
                    <div className="flex items-center bg-muted rounded-lg p-1">
                      <button
                        onClick={() => setViewMode("grid")}
                        className={`p-2 rounded transition-colors ${
                          viewMode === "grid"
                            ? "bg-background text-foreground shadow-sm"
                            : "text-muted-foreground hover:text-foreground"
                        }`}
                      >
                        <Icon name="Grid3X3" size={16} />
                      </button>
                      <button
                        onClick={() => setViewMode("list")}
                        className={`p-2 rounded transition-colors ${
                          viewMode === "list"
                            ? "bg-background text-foreground shadow-sm"
                            : "text-muted-foreground hover:text-foreground"
                        }`}
                      >
                        <Icon name="List" size={16} />
                      </button>
                    </div>

                    {/* Sort Dropdown */}
                    <select
                      value={sortBy}
                      onChange={(e) => setSortBy(e?.target?.value)}
                      className="bg-background border border-border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                    >
                      <option value="popularity">Most Popular</option>
                      <option value="rating">Highest Rated</option>
                      <option value="duration">Duration</option>
                    </select>
                  </div>
                </div>

                {/* Course Grid/List */}
                {filteredAndSortedCourses?.length > 0 ? (
                  <div
                    className={`
                    ${
                      viewMode === "grid"
                        ? "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6"
                        : "space-y-6"
                    }
                  `}
                  >
                    {filteredAndSortedCourses?.map((course) => (
                      <CourseCard
                        key={course?.id}
                        course={course}
                        onCompare={handleCompareToggle}
                        isComparing={comparisonCourses?.some(
                          (c) => c?.id === course?.id,
                        )}
                        onViewDetails={handleViewDetails}
                      />
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-16">
                    <Icon
                      name="Search"
                      size={64}
                      className="text-muted-foreground mx-auto mb-4 opacity-50"
                    />
                    <h3 className="text-xl font-semibold text-foreground mb-2">
                      No courses found
                    </h3>
                    <p className="text-muted-foreground mb-6">
                      Try adjusting your filters or search terms to find more
                      courses.
                    </p>
                    <Button variant="outline" onClick={handleClearFilters}>
                      Clear All Filters
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>

        {/* Comparison Panel */}
        {comparisonCourses?.length > 0 && (
          <div className="fixed bottom-4 right-4 lg:relative lg:bottom-auto lg:right-auto lg:mt-8">
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
              <CourseComparison
                courses={comparisonCourses}
                onRemoveCourse={(courseId) =>
                  setComparisonCourses((prev) =>
                    prev?.filter((c) => c?.id !== courseId),
                  )
                }
                onClearAll={() => setComparisonCourses([])}
                isOpen={isComparisonOpen}
                onToggle={() => setIsComparisonOpen(!isComparisonOpen)}
              />
            </div>
          </div>
        )}

        {/* Floating Comparison Button (Mobile) */}
        {comparisonCourses?.length > 0 && (
          <button
            onClick={() => setIsComparisonOpen(true)}
            className="lg:hidden fixed bottom-4 right-4 bg-primary text-primary-foreground rounded-full p-4 shadow-lg z-40"
          >
            <div className="flex items-center space-x-2">
              <Icon name="GitCompare" size={20} />
              <span className="bg-accent text-accent-foreground rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold">
                {comparisonCourses?.length}
              </span>
            </div>
          </button>
        )}
      </main>
      {/* Course Details Modal */}
      <CourseDetailsModal
        course={selectedCourse}
        isOpen={isDetailsModalOpen}
        onClose={() => {
          setIsDetailsModalOpen(false);
          setSelectedCourse(null);
        }}
      />
    </div>



  );
};

export default CoursesPage;
